/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { GatsbyBrowser } from 'gatsby';

import Layout, { LayoutWithoutGrid } from '~/components/Layout';
import LanguageContextProvider from '~/components/LanguageProvider';

import './src/styles/imports.scss';

// Wraps every page in a component
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return <LanguageContextProvider>{element}</LanguageContextProvider>;
};

// The Ace Knowledge Widget used in Tog-i-Europa does not scroll to the top
// when moving to a new page and the API does not provide a way to do it.
// This is a workaround to scroll to the top for that page.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = (route) => {
  if (route?.location?.hash?.includes('humany-europa=')) {
    const checkForPagination = /(?<=(?:take:))(.*?)(?=(?:;|$))/gs;
    const newPathHash = route?.location?.hash;
    const previousPathHash = route?.prevLocation?.hash;

    const paginationHasChanged = () => {
      const paginationNewPath = new RegExp(checkForPagination).exec(
        newPathHash
      )?.[0];
      const paginationPreviousPath = new RegExp(checkForPagination).exec(
        previousPathHash ?? ''
      )?.[0];

      if (
        // Checks if pagination (i.e. "take:") was added to path since last location.
        // Since guide pages also adds "take:" to path we check if we went from a non-guide to a guide
        paginationPreviousPath === undefined &&
        paginationNewPath !== undefined &&
        (previousPathHash?.includes('guide') || !newPathHash?.includes('guide'))
      )
        return true;
      if (
        // Checks if the pagination number (i.e the number after "take:") was changed to a new value
        paginationPreviousPath !== undefined &&
        paginationNewPath !== undefined &&
        paginationPreviousPath !== paginationNewPath
      )
        return true;
      return false;
    };

    if (!paginationHasChanged()) {
      document
        ?.getElementsByClassName('humany-component-view-area')?.[0]
        ?.scrollIntoView({
          block: 'start',
          inline: 'start',
          behavior: 'smooth',
        });
    }
  }
};
